<template>
    <div class="page-container">
        <el-card shadow="never" class="main-card">
            <!-- 查询条件区 + 操作按钮 -->
            <div class="search-bar">
                <el-tree-select v-model="queryCon.orgId" node-key="id" value-key="id" ref="queryConTreeRef"
                    :data="OrgOptions" :check-strictly="true" default-expand-all style="width:200px;" placeholder="机构"
                    :props="{ label: 'orgName', children: 'children' }" />
                <el-input v-model="queryCon.userName" placeholder="用户名" style="width:200px;" />
                <el-select v-model="queryCon.userType" placeholder="用户类型" style="width:140px;">
                    <el-option label="管理用户" :value="0"></el-option>
                    <el-option label="业务用户" :value="1"></el-option>
                </el-select>
                <el-button-group>
                    <el-button type="primary" :icon="Search" @click="handler.queryHandler">查询</el-button>
                    <el-button :icon="RefreshRight" @click="resetQueryCon">重置</el-button>
                </el-button-group>
                <div class="action-bar">
                    <el-button type="primary" plain :icon="CirclePlusFilled" @click="handler.addHandler">新增</el-button>
                    <el-button type="danger" plain :icon="Delete" @click="handler.deleteBatchHandler">删除</el-button>
                </div>
            </div>

            <!-- 表格区 -->
            <div class="table-wrapper">
                <el-table :data="tableData" v-loading="tableLoading" height="100%" row-key="id" ref="dataTableRef"
                    class="modern-table"
                    :header-cell-style="{ background: '#fafafa', color: '#909399', fontWeight: 500 }">
                    <el-table-column type="selection" width="40" />
                    <el-table-column prop="loginAccount" label="登录帐号" />
                    <el-table-column prop="realName" label="账号名称" width="100" />
                    <el-table-column prop="userType.desc" label="账号类型" width="100" />
                    <el-table-column prop="role.roleName" label="角色" width="120" />
                    <el-table-column prop="status" label="状态" width="80">
                        <template #default="scope">
                            <el-tag v-if="scope.row.status == 0" type="success" effect="plain">正常</el-tag>
                            <el-tag v-else type="info" effect="plain">停用</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="expirationDate" label="有效期" />
                    <el-table-column prop="phoneNo" label="联系电话" width="120" />
                    <el-table-column prop="modifyName" label="修改人" width="100" />
                    <el-table-column prop="modifyDate" label="修改日期" width="170" />
                    <el-table-column label="操作" width="160" fixed="right" header-align="center">
                        <template #default="scope">
                            <el-button size="small" circle :icon="Lock" @click="handler.editPassword(scope.row.id)" />
                            <el-button size="small" circle :icon="Edit" @click="handler.editHandler(scope.row)" />
                            <el-button size="small" circle type="danger" :icon="Delete" @click="handler.deleteHandler(scope.row)" />
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="pagination-wrapper">
                <el-pagination background v-model:current-page="queryCon.currentPage" v-model:page-size="queryCon.pageSize"
                    :page-sizes="pagination.pageInfo.pageSizes" layout="total, sizes, prev, pager, next"
                    :total="pagination.pageInfo.total" @size-change="pagination.handleSizeChange"
                    @current-change="pagination.handleCurrentChange" />
            </div>
        </el-card>

        <el-dialog v-model="dialogFormVisible" title="新建/编辑" width="800">
            <el-form :inline="true" :model="form" :label-position="top" label-width="auto" :rules="rules" status-icon
                ref="dataFormRef">
                <el-form-item v-show="false" label="id" prop="id">
                    <el-input v-model="form.id"></el-input>
                </el-form-item>
                <el-form-item label="登录帐号" prop="loginAccount">
                    <el-input v-model="form.loginAccount" autocomplete="off" class="el-input-width" />
                </el-form-item>
                <el-form-item label="密码" prop="password" v-show="isAdd">
                    <el-input v-model="form.password" autocomplete="off" type="password" class="el-input-width" />
                </el-form-item>
                <el-form-item label="用户类型" prop="userType">
                    <el-select placeholder="用户类型" v-model="form.userType.code" class="el-input-width">
                        <el-option label="管理用户" :value="0"></el-option>
                        <el-option label="业务用户" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="组织机构" prop="orgId">
                    <el-tree-select v-model="form.orgId" value-key="id" placeholder="请选择组织机构" class="el-input-width"
                        :data="OrgOptions" default-expand-all :loading="loading" :props="{ label: 'orgName' }" node-key="id"
                        check-strictly=true />
                </el-form-item>
                <el-form-item label="角色" prop="roleId">
                    <el-select v-model="form.roleId" placeholder="请选择角色" class="el-input-width" reserve-keyword
                        :loading="loading">
                        <el-option v-for="(item) in roleOptions" :key="item.id" :label="item.roleName +'('+item.roleType.desc+')'"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户名称" prop="realName">
                    <el-input v-model="form.realName" autocomplete="off" class="el-input-width" />
                </el-form-item>
                <el-form-item label="电话" prop="phoneNo">
                    <el-input v-model="form.phoneNo" autocomplete="off" class="el-input-width" />
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                    <el-select placeholder="性别" v-model="form.sex" class="el-input-width">
                        <el-option label="女" :value="'女'"></el-option>
                        <el-option label="男" :value="'男'"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="form.email" autocomplete="off" class="el-input-width" />
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select placeholder="性别" v-model="form.status" class="el-input-width">
                        <el-option label="正常" :value="0"></el-option>
                        <el-option label="停用" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="过期日期" prop="expirationDate">
                    <el-date-picker v-model="form.expirationDate" type="date" value-format="YYYY-MM-DD" placeholder="请设定有效期" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="handler.saveHandler">保存</el-button>
                </div>
            </template>
        </el-dialog>

        <el-dialog v-model="pwdDialogFormVisible" title="修改密码" width="400">
            <el-form :inline="true" :model="pwdForm" :label-position="top" label-width="auto" :rules="pwdRules" status-icon
                ref="pwdDataFormRef">
                <el-form-item v-show="false" label="id" prop="id">
                    <el-input v-model="pwdForm.id"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="password">
                    <el-input v-model="pwdForm.password" type="password" autocomplete="off" class="el-input-width" />
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input v-model="pwdForm.confirmPassword" type="password" autocomplete="off" class="el-input-width" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="pwdDialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="handler.changePassword">保存</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<style lang="css" scoped>
@import '../../../src/assets/styles/common.css';
</style>

<script setup>
import { nextTick, ref, reactive, onMounted } from 'vue';
import "@/assets/styles/crud-page.css";
import { ElTable, ElMessageBox, ElMessage, ElSelect, ElOption } from 'element-plus';
import { Delete, CirclePlusFilled, Search, Edit, RefreshRight, Lock } from '@element-plus/icons-vue';
import 'element-plus/dist/index.css';
import { userApi } from '@/api/user-api.js';
import { roleApi } from '@/api/role-api.js';
import { orgApi } from '@/api/org-api.js';
import CryptoJS from 'crypto-js';

//状态标志
const dialogFormVisible = ref(false);
const pwdDialogFormVisible = ref(false);
const tableLoading = ref(false);
const isAdd = ref(false);

//数据
const tableData = ref([]);
const roleOptions = ref([]);
const OrgOptions = ref([]);

//引用
const dataTableRef = ref(null);
const dataFormRef = ref(null);
const pwdDataFormRef = ref(null);

//查询条件与分页
const queryCon = reactive({ userName: '', orgId: null, queryCon:null,pageSize: 10, currentPage: 1 });
const resetQueryCon = () => {
    queryCon.userName = '';
    queryCon.orgId = null;
    queryCon.userType = null;
    queryCon.pageSize = 10;
    queryCon.currentPage = 1;
}
const pagination = {
    pageInfo: reactive({
        total: 0,
        pageSizes: [10, 20, 30, 50, 100]
    }),
    handleSizeChange: (val) => {
        queryCon.pageSize = val;
        handler.queryHandler();
    },
    handleCurrentChange: (val) => {
        queryCon.currentPage = val;
        handler.queryHandler();
    }
}

//表单对象
const form = reactive({
    id: null,
    loginAccount: '',
    password: '',
    realName: '',
    roleId: null,
    userType: {code:null},
    orgId: null,
    phoneNo: '',
    sex: '男',
    email: '',
    status: 0,
    expirationDate: null
});
const resetForm = () => {
    dataFormRef.value?.resetFields();
};
const rules = {
    loginAccount: [{ required: true, message: '登录账号不能为空', trigger: 'blur' }],
    expirationDate: [{ required: true, message: '请选择过期日期', trigger: 'blur' }],
    password: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
    userType: [{ required: true, message: '请选择用户类型', trigger: 'blur' }],
    roleId: [{ required: true, message: '请选择角色', trigger: 'blur' }],
    orgId: [{ required: true, message: '请选择机构', trigger: 'blur' }],
    email: [
        { required: true, message: '请输入邮箱', trigger: 'blur' },
        { type: 'email', message: '邮箱格式不正确' }
    ]
};

//改密码
const pwdForm = reactive({
    id: null,
    password: null,
    confirmPassword: null
});
const resetpwdForm = () => {
    pwdDataFormRef.value?.resetFields();
};
const validateConfirmPassword = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请再次输入密码'))
    } else if (value !== pwdForm.password) {
        callback(new Error('两次输入密码不一致!'))
    } else {
        callback()
    }
}

const pwdRules = {
    password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
    confirmPassword: [{ required: true, validator: validateConfirmPassword, trigger: 'blur' }]
};

//根据选择的机构，加载机构的角色
async function loadRoles() {
    const response = await roleApi.listRole();
    form.roleId = null;
    if (response.data.errorCode === "00000") {
        roleOptions.value = response.data.result;
    } else {
        return [];
    }
}

async function init() {
    //初始化机构数据
    const orgOptions = await orgApi.loadOrgOptions();
    await loadRoles();
    OrgOptions.value = orgOptions;
    if (orgOptions && orgOptions.length > 0) {
        queryCon.orgId = orgOptions[0].id; // 设置为第一项的值
    }
}

//生命周期
onMounted(async () => {
    //等待数据初始化完成
    await init();
    handler.queryHandler();
});

//UI界面逻辑
const handler = {
    queryHandler() {
        tableLoading.value = true;
        userApi.pageUser(queryCon).then((response) => {
            if (response.data.errorCode === "00000") {
                tableData.value = response.data.result.records;
                pagination.pageInfo.total = response.data.result.total;
            } else {
                ElMessage.error(`操作失败，${response.data.errorMessage}![错误码:${response.data.errorCode}]`);
            }
        }).finally(function () {
            tableLoading.value = false;
        });
    },
    addHandler() {
        isAdd.value = true;
        resetForm();
        dialogFormVisible.value = true;
    },
    editHandler(rowObj) {
        isAdd.value = false;
        resetForm();
        dialogFormVisible.value = true;
        nextTick(() => {
            Object.assign(form, rowObj);
            form.roleId = rowObj.role.id;
        })
    },
    deleteHandler(rowObj) {
        ElMessageBox.confirm(
            '确认要删除吗?',
            '删除确认',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        ).then(() => {
            userApi.deleteUser([rowObj.id])
                .then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '删除成功.', type: 'success' });
                        handler.queryHandler();
                    } else {
                        ElMessage.error(`系统异常[ ErrorCode:${response.data.errorCode} ]`);
                    }
                })
        }).catch(() => {})
    },
    deleteBatchHandler() {
        var selectedRows = dataTableRef.value.getSelectionRows();
        if (selectedRows && selectedRows.length == 0) { ElMessage("没有选中任何行"); return; }

        var ids = [];
        selectedRows.forEach(function (item) {
            ids.push(item.id);
        });

        ElMessageBox.confirm(
            '确认要删除吗?',
            '删除确认',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        ).then(() => {
            userApi.deleteUser(ids)
                .then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '删除成功.', type: 'success' });
                        handler.queryHandler();
                    } else {
                        ElMessage.error(`系统异常[ ErrorCode:${response.data.errorCode} ]`);
                    }
                })
        }).catch(() => {})
    },
    saveHandler() {
        dataFormRef.value.validate((valid) => {
            if (valid) {
                form.password = CryptoJS.SHA256(form.password).toString();
                userApi.saveUser(form).then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '保存成功', type: 'success' });
                        handler.queryHandler();
                        dialogFormVisible.value = false;
                    } else {
                        ElMessage.error(`操作失败，${response.data.errorMessage}![错误码:${response.data.errorCode}]`);
                    }
                })
            }
        });
    },
    editPassword(userId) {
        resetpwdForm();
        pwdForm.id = userId;
        pwdDialogFormVisible.value = true;
    },
    changePassword() {
        pwdDataFormRef.value.validate((valid) => {
            if (valid) {
                pwdForm.password = CryptoJS.SHA256(pwdForm.password).toString();
                userApi.changePassword(pwdForm).then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '密码修改成功', type: 'success' });
                        pwdDialogFormVisible.value = false;
                    } else {
                        ElMessage.error("系统出错[errorCode:" + response.data.errorCode + "]");
                    }
                })
            }
        });
    }
}
</script>
